import React, { useState, useEffect } from 'react';
import './Hero.css';
import poster4 from '../Assets/demo_part.jpg';
import { API_BASE } from '../../config/api';

const Hero = () => {
  const [banner, setBanner] = useState({ imageUrl: '', title: '', subtitle: '' });

  useEffect(() => {
    fetch(`${API_BASE}/hero-banner`)
      .then((res) => res.json())
      .then((data) => setBanner(data))
      .catch(() => {});
  }, []);

  const imageSrc = banner?.imageUrl?.trim() ? banner.imageUrl : poster4;

  return (
    <div className="hero">
      <img
        src={imageSrc}
        alt="Jewellery Display"
        className="hero-background"
      />
      <div className="hero-content">
        {banner?.title && <h1>{banner.title}</h1>}
        {banner?.subtitle && <p>{banner.subtitle}</p>}
      </div>
    </div>
  );
};

export default Hero;
